import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';
import { ContentActionComponent } from 'src/app/shared/content-action/content-action.component';
import {SelectionModel} from '@angular/cdk/collections';
import { ClonePlanModalComponent } from '../clone-plan-modal/clone-plan-modal.component';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { FilterFormModal, FilterValue } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';

export interface DisplayColumn { name: string; property: string; visible: boolean }
export interface formControl { planOptionalItemCategory: string, planPropertySize: string, planPropertyType: string }

@Component({
  selector: 'fury-plan-price-list',
  templateUrl: './plan-price-list.component.html',
  styleUrls: ['./plan-price-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class PlanPriceListComponent implements OnInit, OnDestroy {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input() columns: DisplayColumn[] = [
    { name: 'Select', property: 'select', visible: true, isModelProperty: true },
    { name: 'Plan Type', property: 'plan_optional_item_category', visible: true },
    { name: 'Property type', property: 'plan_property_type', visible: true },
    { name: 'Property size', property: 'plan_property_size', visible: true },
    { name: 'Displayed Monthly Pricing', property: 'displayMonthlyPrice', visible: true },
    { name: 'Discounted Monthly Pricing', property: 'discountedMonthlyPrice', visible: true },
    { name: 'Displayed Annual pricing', property: 'displayYearlyPrice', visible: true },
    { name: 'Discounted Annual pricing', property: 'discountedYearlyPrice', visible: true },
    { name: 'Displayed 2 Years Pricing', property: 'displayTwoYearlyPrice', visible: true },
    { name: 'Discounted 2 Years Pricing', property: 'discountedTwoYearlyPrice', visible: true },
    { name: 'Displayed 3 Years Pricing', property: 'displayThreeYearlyPrice', visible: true },
    { name: 'Discounted 3 Years Pricing', property: 'discountedThreeYearlyPrice', visible: true },
    { name: 'Displayed 4 Years Pricing', property: 'displayFourYearlyPrice', visible: true },
    { name: 'Discounted 4 Years Pricing', property: 'discountedFourYearlyPrice', visible: true },
    { name: 'Displayed 5 Years Pricing', property: 'displayFiveYearlyPrice', visible: true },
    { name: 'Discounted 5 Years Pricing', property: 'discountedFiveYearlyPrice', visible: true },
    { name: 'Monthly Free Month', property: 'monthlyFreeMonth', visible: true },
    { name: 'Annually Free Month', property: 'annuallyFreeMonth', visible: true },
    { name: 'Two Years Free Month', property: 'twoYearsFreeMonth', visible: true },
    { name: 'Three Years Free Month', property: 'threeYearsFreeMonth', visible: true },
    { name: 'Four Years Free Month', property: 'fourYearsFreeMonth', visible: true },
    { name: 'Five Years Free Month', property: 'fiveYearsFreeMonth', visible: true },
    { name: 'Actions', property: 'actions', visible: true }
  ] as DisplayColumn[];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  pageIndex: number = 0;
  filterkeyword: string = '';
  itemList: any;
  totalCount: number = 0;
  @ViewChild(MatSort, { static: false }) sort!: MatSort; filterValue: any;
  pageSize: number = 30;
  planCoverItems: any = [];
  planTypeOption: any = [];
  planOptionalItemCategory = new FormControl('');
  planPropertyType = new FormControl('');
  planPropertySize = new FormControl('');
  planSizeOption: any = [];
  selection = new SelectionModel(true, []);
  ngUnsubscribe  = new Subject<void>();
  searchBy: string = 'planType';
  searchType: string = 'contains';
  isShowFilter: boolean = false;
  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });
  serchByValue: FilterValue[] = [
    { title: "Plan Type", value: "planType" },
    { title: "Property Type", value: "propertyType" },
    { title: "Property Size", value: "propertySize" },
  ];

  constructor(
    private router: Router, 
    private api: ApiService, 
    private cdr: ChangeDetectorRef, 
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    public commonService: CommonService
    ) { }
  get visibleColumns() {
    return this.columns.filter((column: DisplayColumn) => column.visible).map((column: DisplayColumn) => column.property);
  }
  ngOnInit(): void {
    this.router.onSameUrlNavigation = 'reload';
    this.activatedRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.filterkeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
      this.searchBy = res.searchBy ? res.searchBy : 'planType';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });
      this.getPlanPriceList();
    }) 
    this.loadEverything()
  }

  onFilterChange(value: any, controls?: any) {
    if (controls) {
      controls.forEach((ele: any) => { this[ele as keyof formControl].setValue('') });
    }
    this.pageIndex = 0;
    this.filterkeyword = value ? value.trim() : ''; 
    this.router.navigateByUrl(`/plan-management/plan-price/plan-price-list?page=${this.pageIndex + 1}${this.filterkeyword ? '&keywords=' + this.filterkeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
  }
  getPlanPriceList(){
    this.api.get(`admin/plan/plan-price/get-plan-prices?page=${Number(this.pageIndex + 1)}&size=${this.pageSize}${this.filterkeyword ? '&keywords=' + this.filterkeyword : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`)
      .subscribe((res: any) => {
        if (res.status === 200) {
          this.itemList = res.body.planPrices.data;
          this.dataSource = new MatTableDataSource(this.itemList);
          this.cdr.detectChanges();
          this.totalCount = res.body.planPrices.total;
          this.dataSource.sort = this.sort;
          this.selection.clear();
        }
      });
  }
 
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(`/plan-management/plan-price/plan-price-list?page=${this.pageIndex + 1}${this.filterkeyword ? '&keywords=' + this.filterkeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
  }


  deletePlanPrice(type: string, value: any): void {
    const obj = { width: '500px', data: { type, value } }
    const dialogref = this.dialog.open(ContentActionComponent, obj);
    dialogref.afterClosed().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.api.delete(`admin/plan/plan-price/delete-plan-price/${value.planPriceId}`)
          .subscribe({
            next: (del: HttpResponse<any>) => {
              if (del.status === 200) {
                this.api.alert(del.body.message, ErrorType.Success);
                this.getPlanPriceList();
              }
            }, error: (err: HttpErrorResponse) => { if (err) this.api.alert(ErrorText.SomeThingWentWrong, ErrorType.Error) }
          });
      }
    });
  }

  loadEverything() {
    this.api.get('admin/plan/property-type/get-property-types?page=1&size=9999').pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>) => {
      if (res && res['body']['planPropertyTypes']) this.planTypeOption = res['body']['planPropertyTypes']['data']
    });
    this.api.get('admin/plan/property-size/get-property-sizes?page=1&size=9999').pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>) => {
      if (res && res['body']['planPropertySizes']) this.planSizeOption = res['body']['planPropertySizes']['data']
    });
  }

  filterOptionalItem(event: any) {
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  };

  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  };
  openClonePlanModal(){
    if(this.selection.selected.length){
      const obj = { width: '500px', disableClose: true, data: {planPriceId: this.selection.selected.map((item: any)=> item?.planPriceId), propertyTypes: this.planTypeOption, propertySizes: this.planSizeOption}}
      const dialogRef = this.dialog.open(ClonePlanModalComponent, obj);
      dialogRef.afterClosed().pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
        if (result) {
          this.getPlanPriceList();
        }
      });
    } else {
      this.api.alert('Please select plan', ErrorType.Error);
    }
   
  }
  showFilter() {
    this.isShowFilter = !this.isShowFilter;
  }
  filterChange() {
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/plan-management/plan-price/plan-price-list?page=${this.pageIndex + 1}${this.filterkeyword ? '&keywords=' + this.filterkeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.isShowFilter = false;
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
